import Vue from "vue";
import Vuex from "vuex";
import { appModule } from "@/store/app";
import { disposerModule } from "@/store/disposer";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    app: appModule,
    disposerManagement: disposerModule,
  },
  getters: {},
});
